import { routeName } from '@/constants/routeName';
import basicOptions from '@/router/basic-options';
import { pageAuthorization } from '@/router-middleware';
import { userPermission } from '@/constants';
export default [
    {
        path: 'store-stats',
        name: routeName.STORE_STATS,
        component: () => import('@/views/StoreStats/index.vue'),
        redirect: {
            name: routeName.STORE_STATS_DAILY,
        },
        children: [
            {
                path: 'daily',
                name: routeName.STORE_STATS_DAILY,
                component: () => import('@/views/StoreStats/content.vue'),
                meta: {
                    ...basicOptions,
                    middleware: [
                        pageAuthorization([
                            userPermission.P_GET_STORE_STATS,
                        ]),
                        ...basicOptions.middleware,
                    ],
                },
            },
            {
                path: 'monthly',
                name: routeName.STORE_STATS_MONTHLY,
                component: () => import('@/views/StoreStats/content.vue'),
                meta: {
                    ...basicOptions,
                    middleware: [
                        pageAuthorization([
                            userPermission.P_GET_STORE_STATS,
                        ]),
                        ...basicOptions.middleware,
                    ],
                },
            },
            {
                path: 'day-of-week',
                name: routeName.STORE_STATS_DAY_OF_WEEK,
                component: () => import('@/views/StoreStats/content.vue'),
                meta: {
                    ...basicOptions,
                    middleware: [
                        pageAuthorization([
                            userPermission.P_GET_STORE_STATS,
                        ]),
                        ...basicOptions.middleware,
                    ],
                },
            },
            {
                path: 'hourly',
                name: routeName.STORE_STATS_HOURLY,
                component: () => import('@/views/StoreStats/content.vue'),
                meta: {
                    ...basicOptions,
                    middleware: [
                        pageAuthorization([
                            userPermission.P_GET_STORE_STATS,
                        ]),
                        ...basicOptions.middleware,
                    ],
                },
            },
            {
                path: 'share-store',
                name: routeName.STORE_STATS_SHARE_STORE,
                component: () => import('@/views/StoreStats/content.vue'),
                meta: {
                    ...basicOptions,
                    middleware: [
                        pageAuthorization([
                            userPermission.P_GET_STORE_STATS,
                        ]),
                        ...basicOptions.middleware,
                    ],
                },
            },
        ],
    },
];
